import { StakeholderEmails } from "./StakeholderEmails_view";

export const STAKEHOLDER_EMAILS_MODAL_CONFIG = (itemIds: number[], projectId: number) => {
  return {
    showClose: true,
    title: null,
    content: <StakeholderEmails itemIds={itemIds} projectId={projectId} />
  };
};
